// Alto y tamaño de letra de todo campo de una línea (input, trigger del select): 36px y 13px.
export const FIELD_BOX = 'h-9 text-[13px]';
